{
  "version": "4.7.0-limit-reports-hc.754",
  "scripts": {
    "sonar-scanner": "sonar-scanner"
  },
  "buildDate": "26.10.2026, 16:36:19",
  "commitId": "5b7b254579e62918da27b68f3a2aa69c2eac43ac"
}
